var flagCache = {};
/**
 * Clears cache entries selectively based on the provided clientId or entirely if no clientId is specified.
 * This function is intended for use in testing environments to reset the cache between unit tests.
 * It is not recommended for use in production environments as it deletes all cache entries and notifies
 * all subscribers, which could lead to unintended side effects.
 *
 * @param {string|null} [clientId=null] - The clientId whose cache is to be cleared. If null or omitted, all cache entries are cleared.
 *
 * @example
 * // Example of clearing the entire cache
 * clearCache();
 *
 * // Example of clearing the cache for a specific client
 * clearCache({ clientId: 'client123' });
 */ var clearCache = function(param) {
    var _ref = param === void 0 ? {
        optionalClientId: null
    } : param, optionalClientId = _ref.clientId;
    for(var clientId in flagCache){
        if (!optionalClientId || clientId === optionalClientId) {
            var _flagCache_clientId_state, _flagCache_clientId, _flagCache;
            var _flagCache_clientId_state_subscribers;
            var subscribers = (_flagCache_clientId_state_subscribers = (_flagCache = flagCache) == null ? void 0 : (_flagCache_clientId = _flagCache[clientId]) == null ? void 0 : (_flagCache_clientId_state = _flagCache_clientId.state) == null ? void 0 : _flagCache_clientId_state.subscribers) != null ? _flagCache_clientId_state_subscribers : new Set();
            delete flagCache[clientId];
            subscribers.forEach(function(callback) {
                return callback();
            });
        }
    }
};
// Adds a new subscriber to an entry and returns the unsubscribe function
/**
 * @param  {string} clientId: Must match an existing cache key
 * @param  {function} callback: A callback function which will be called when cache state updates
 * @returns {function} An unsubscribe function which removes the subscription from the set of subscribers
 */ function observe(clientId, callback) {
    var _flagCache_clientId, _flagCache;
    if (!((_flagCache = flagCache) == null ? void 0 : (_flagCache_clientId = _flagCache[clientId]) == null ? void 0 : _flagCache_clientId.state)) {
        return function() {};
    }
    if (!flagCache[clientId].state.subscribers) {
        flagCache[clientId].state.subscribers = new Set();
    }
    flagCache[clientId].state.subscribers.add(callback);
    return function() {
        var _flagCache_clientId_state, _flagCache_clientId, _flagCache;
        (_flagCache = flagCache) == null ? void 0 : (_flagCache_clientId = _flagCache[clientId]) == null ? void 0 : (_flagCache_clientId_state = _flagCache_clientId.state) == null ? void 0 : _flagCache_clientId_state.subscribers.delete(callback);
    };
}
/**
 * Triggers all callbacks for a given cache entry (typically triggers react re-renders)
 * @param  {string} clientId: Must match an existing cache key
 */ var notifyObservers = function(param) {
    var clientId = param.clientId;
    var _flagCache_clientId_state_subscribers, _flagCache_clientId_state, _flagCache_clientId, _flagCache;
    return (_flagCache = flagCache) == null ? void 0 : (_flagCache_clientId = _flagCache[clientId]) == null ? void 0 : (_flagCache_clientId_state = _flagCache_clientId.state) == null ? void 0 : (_flagCache_clientId_state_subscribers = _flagCache_clientId_state.subscribers) == null ? void 0 : _flagCache_clientId_state_subscribers.forEach(function(sub) {
        var _sub;
        return (_sub = sub) == null ? void 0 : _sub(flagCache[clientId]);
    });
};
export { flagCache, clearCache, observe, notifyObservers };
